import Chip from "@material-ui/core/Chip";
import amber from "@material-ui/core/colors/amber";
import green from "@material-ui/core/colors/green";
import red from "@material-ui/core/colors/red";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import React from "react";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.text.primary,
    },
    chipNominal: {
      backgroundColor: green[500],
      color: theme.palette.common.white,
    },
    chipDeviation: {
      backgroundColor: red[500],
      color: theme.palette.common.white,
    },
    chipEmpty: {
      backgroundColor: amber[500],
    },
  });

interface ReadOnlyDeviationChipProps extends WithStyles<typeof styles> {
  value: boolean | null | undefined;
  deviationValue: boolean;
  emptyValue?: string;
  hasNominalColor?: boolean;
  hasEmptyColor?: boolean;
  className?: string;
}

export const ReadOnlyDeviationChipComponent = (props: ReadOnlyDeviationChipProps) => {
  const { value, deviationValue, emptyValue, hasNominalColor, hasEmptyColor, className, classes } = props;

  return (
    <div className={classNames(classes.root, className)}>
      {value != null ? (
        <Chip
          label={value ? "Yes" : "No"}
          className={
            value === deviationValue ? classes.chipDeviation : hasNominalColor ? classes.chipNominal : undefined
          }
        />
      ) : hasEmptyColor ? (
        <Chip label={emptyValue} className={classes.chipEmpty} />
      ) : (
        emptyValue
      )}
    </div>
  );
};

export const ReadOnlyDeviationChip = withStyles(styles)(ReadOnlyDeviationChipComponent);
